export default "__VITE_ASSET__MJdTq8l8__"